import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Cookie, ShieldCheck, Check } from 'lucide-react';

export default function CookieConsentBanner() {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  // Jangan tampilkan di portal internal (/office) atau login/digitalmarketing
  const isInternalPortal = location.pathname.startsWith('/office') || 
                           location.pathname.startsWith('/login') || 
                           location.pathname.startsWith('/digitalmarketing');

  useEffect(() => {
    if (isInternalPortal) {
      setIsVisible(false);
      return;
    }

    // AUTO-ACCEPT & IMPLIED CONSENT STRATEGY:
    // Aktifkan pelacakan cookie & Meta Pixel secara otomatis 100% untuk semua pengunjung
    localStorage.setItem('satala_cookie_consent', 'accepted');
    window.dispatchEvent(new Event('satala_cookie_consent_accepted'));

    // Cek apakah banner sudah pernah ditutup oleh pengguna
    const dismissed = localStorage.getItem('satala_cookie_banner_dismissed');
    if (!dismissed) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, isInternalPortal]);

  // Otomatis tutup banner saat pengguna melakukan scroll pada halaman (Implied Consent)
  useEffect(() => {
    if (!isVisible) return;

    const handleScroll = () => {
      if (window.scrollY > 150) {
        handleDismiss();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isVisible]);

  const handleDismiss = () => {
    localStorage.setItem('satala_cookie_banner_dismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible || isInternalPortal) return null;

  return (
    <div className="fixed bottom-5 left-5 right-5 sm:left-6 sm:right-auto sm:max-w-md z-50 animate-in slide-in-from-bottom-5 fade-in duration-500">
      <div className="bg-[#1E1915]/95  text-white border border-[#D4AF37]/40 rounded-2xl p-5 shadow-2xl shadow-black/50 space-y-4 font-sans">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/20 border border-[#D4AF37]/40 flex items-center justify-center shrink-0 text-[#D4AF37]">
            <Cookie className="w-5 h-5" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h4 className="font-extrabold text-sm text-[#F5E6C8] tracking-tight">Privasi & Pengalaman Optimal</h4>
              <span className="text-[10px] font-bold bg-amber-500/20 text-[#D4AF37] px-2 py-0.5 rounded-md flex items-center gap-1 border border-[#D4AF37]/30">
                <ShieldCheck className="w-3 h-3" /> Terenkripsi
              </span>
            </div>
            <p className="text-xs text-slate-300 mt-1.5 leading-relaxed">
              Website Satala Dermatech menggunakan cookie untuk memastikan simulasi harga paket maklon presisi dan memberikan pengalaman konsultasi terbaik untuk Anda.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between pt-1 border-t border-slate-700/60">
          <span className="text-[10px] text-slate-400 font-medium">Scroll untuk melanjutkan</span>
          <button
            onClick={handleDismiss}
            className="px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#C99B45] hover:from-[#C99B45] hover:to-[#B88A34] text-white text-xs font-extrabold rounded-xl shadow-md transition-all flex items-center gap-1.5 active:scale-95 cursor-pointer"
          >
            <Check className="w-4 h-4" /> Saya Mengerti & Lanjutkan
          </button>
        </div>
      </div>
    </div>
  );
}
